// extracted by mini-css-extract-plugin
export default {"copyBtn":"CopyToClipboard_copyBtn__Oxtr1","icon":"CopyToClipboard_icon__9-xXp"};